import { FormulaCicloEmpresaRascunho } from '../../structs/formula/formula-ciclo-empresa-rascunho.struct';
import { CalculoFormulaEntradaRequest } from './calculo-formula-entrada.request';
import { CalculoFormulaEstadoRequest } from './calculo-formula-estado.request';

/**
 * Simulação genérica de fórmulas (`POST MotorCalculo/simular`, MotorFiscal e Suprimentos).
 * As entradas são as variáveis referenciadas pelas fórmulas do contexto que não são saída do próprio contexto.
 */
export class CalculoFormulaSimularRequest {
    /** Chave do contexto raiz (filhos incluídos), a mesma usada pela tela para carregar o catálogo. */
    contextoRaiz: string;
    /** Rascunho das fórmulas em edição na tela, inclusive alterações ainda não salvas. */
    formulas: CalculoFormulaEstadoRequest[] = [];
    /** Somente MotorFiscal; Suprimentos ignora. */
    ciclosEmpresa?: FormulaCicloEmpresaRascunho[];
    /** Data ISO (yyyy-MM-dd); quando ausente, a API usa a data atual. */
    dataReferenciaCalculo?: string | null;
    entradas: CalculoFormulaEntradaRequest[] = [];
}
